import { Menu, MenuItem, PopoverPosition } from "@mui/material";
import { mixpanel } from "common/analytics";
import { useTranslation } from "common/locales";
import { FieldPreparationEvent } from "model";
import { Dispatch, SetStateAction } from "react";

interface Props {
  fieldPreparationEvent: FieldPreparationEvent;
  anchor: HTMLElement | null;
  anchorPosition?: PopoverPosition;
  close: () => void;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}
export default function FieldPreparationEventMoreMenu({
  fieldPreparationEvent,
  anchor,
  anchorPosition,
  close,
  setDialogOpen,
}: Props) {
  const { t } = useTranslation();
  return (
    <Menu
      anchorEl={anchor}
      anchorPosition={anchorPosition}
      anchorReference={
        anchor ? "anchorEl" : anchorPosition ? "anchorPosition" : "none"
      }
      open={anchor ? anchor.id === fieldPreparationEvent.guid : false}
      onClose={close}
      key={`fe-menu-${fieldPreparationEvent.guid}`}
    >
      <MenuItem
        key={`fe-menuitem-edit-${fieldPreparationEvent.guid}`}
        onClick={() => {
          mixpanel.track("Edit/view fieldPreparation event clicked");
          setDialogOpen(true);
          close();
        }}
      >
        {t("yieldEvent.menu.editView")}
      </MenuItem>
    </Menu>
  );
}
